var render = function render(){var _vm=this,_c=_vm._self._c;return _c('audio',{ref:"audio",attrs:{"src":_vm.src,"loop":"","preload":"auto","playsinline":""},on:{"canplaythrough":_vm.tryStart}})
}
var staticRenderFns = []

export { render, staticRenderFns }